var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "focus-trap",
    {
      attrs: {
        "initial-focus": function initialFocus() {
          return _vm.initialFocusElement
        },
        clickOutsideDeactivates: true,
        fallbackFocus: function fallbackFocus() {
          return _vm.fallbackFocusElement
        },
      },
      model: {
        value: _vm.trap,
        callback: function callback($$v) {
          _vm.trap = $$v
        },
        expression: "trap",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-ribbon-tools",
          class: {
            unfold: _vm.toolsActive,
            "cw-ribbon-tools-consume": _vm.consumeMode,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-ribbon-tool-content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "cw-ribbon-tool-content-nav",
                },
                [
                  _c(
                    "courseware-tabs",
                    {
                      ref: "tabs",
                      staticClass: "cw-ribbon-tool-content-tablist",
                    },
                    [
                      _c(
                        "courseware-tab",
                        {
                          ref: "contents",
                          attrs: {
                            name: _vm.$gettext("Inhaltsverzeichnis"),
                            selected: _vm.showContents,
                            alias: "contents",
                            index: 0,
                          },
                        },
                        [
                          _c("courseware-tools-contents", {
                            attrs: {
                              id: "cw-ribbon-tool-contents",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("button", {
                    ref: "closeTools",
                    staticClass: "cw-tools-hide-button",
                    attrs: {
                      title: _vm.$gettext("schließen"),
                    },
                    on: {
                      click: function click($event) {
                        return _vm.$emit("deactivate")
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }